import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const PlanesPage = lazy(() => import('../pages/planes/page'));
const DestinationsPage = lazy(() => import('../pages/destinations/page'));
const WhyYesjetsPage = lazy(() => import('../pages/why-yesjets/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TimeValuePage = lazy(() => import('../pages/time-value/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/planes',
    element: <PlanesPage />,
  },
  {
    path: '/destinations',
    element: <DestinationsPage />,
  },
  {
    path: '/why-yesjets',
    element: <WhyYesjetsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/time-value',
    element: <TimeValuePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;